var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "600" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _vm.movilidad.id_tipo_justificacion === 7 ||
      _vm.movilidad.id_tipo_justificacion === 1 ||
      _vm.movilidad.id_tipo_justificacion === 14
        ? _c("aprobar-movilidad-item", { attrs: { movilidad: _vm.movilidad } })
        : _vm._e(),
      _vm._v(" "),
      _vm.movilidad.id_tipo_justificacion === 5 ||
      _vm.movilidad.id_tipo_justificacion === 6 ||
      _vm.movilidad.id_tipo_justificacion === 10
        ? _c("aprobar-retiro", { attrs: { movilidad: _vm.movilidad } })
        : _vm._e(),
      _vm._v(" "),
      _vm.movilidad.id_tipo_justificacion === 11 ||
      _vm.movilidad.id_tipo_justificacion === 2
        ? _c("aprobar-comision-servicio", {
            attrs: { movilidad: _vm.movilidad }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.movilidad.id_tipo_justificacion == 15
        ? _c("aprobar-reestructuracion", {
            attrs: { movilidad: _vm.movilidad }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8b8da2b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b8da2b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/movilidad/dialogs/AprobarTipoMovilidad.vue
// module id = null
// module chunks = 